import { render, staticRenderFns } from "./categories-actions-column.vue?vue&type=template&id=aa436c5e"
import script from "./categories-actions-column.vue?vue&type=script&lang=js"
export * from "./categories-actions-column.vue?vue&type=script&lang=js"
import style0 from "./categories-actions-column.vue?vue&type=style&index=0&id=aa436c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports